(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomResourceTypeAttributeDialogController', CustomResourceTypeAttributeDialogController);

    CustomResourceTypeAttributeDialogController.$inject = ['$timeout', '$scope', '$state','$stateParams', 'entity', 'CustomResourceTypeAttribute'];

    function CustomResourceTypeAttributeDialogController ($timeout, $scope, $state ,$stateParams, entity, CustomResourceTypeAttribute) {
        var vm = this;

        vm.customResourceTypeAttribute = entity;
        vm.clear = clear;
        vm.save = save;
       // vm.customresourcetypeattributevalues = CustomResourceTypeAttributeValue.query();
        
        vm.items = [ {
			value : ''
		} ];
        
        if (vm.customResourceTypeAttribute.customResourceTypeAttributeValues != null && vm.customResourceTypeAttribute.customResourceTypeAttributeValues.length != 0) {
			vm.items = vm.customResourceTypeAttribute.customResourceTypeAttributeValues;
		}
        vm.addmore = function() {
			vm.items.push({
				value : ''
			});
		};

		vm.remove = function(index) {
			vm.items.splice(index, 1);
		};

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            //$uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if  ( vm.customResourceTypeAttribute.id !== null) {
            	
            	 vm.customResourceTypeAttribute.customResourceTypeAttributeValues = [];
				for (var i = 0; i < vm.items.length; i++) {
					 vm.customResourceTypeAttribute.customResourceTypeAttributeValues.push({
						"id" : vm.items[i].id,
						"value" : vm.items[i].value
					});

				}
                CustomResourceTypeAttribute.update(vm.customResourceTypeAttribute, onSaveSuccess, onSaveError);
            } else {
            	
            	
            	 vm.customResourceTypeAttribute.customResourceTypeAttributeValues = [];

				for (var i = 0; i < vm.items.length; i++) {
					 vm.customResourceTypeAttribute.customResourceTypeAttributeValues.push({
						"id" : vm.items[i].id,
						"value" : vm.items[i].value
					});

				}
				
                CustomResourceTypeAttribute.save(vm.customResourceTypeAttribute, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('trakeyeApp:customResourceTypeAttributeUpdate', result);
           // $uibModalInstance.close(result);
            vm.isSaving = false;
            $state.go('custom-resource-type-attribute');
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
